import manifest from "../../content/generated/route-manifest.json";
import type { ContentCategory, ContentRouteEntry } from "../../domain/content-schema";
import { repairLegacyEncoding } from "../../platform/content/repairLegacyEncoding";

export type PageLink = Readonly<{ path: string; label: string }>;
export type PageContext = Readonly<{
  breadcrumbs: readonly PageLink[];
  parent: PageLink;
}>;

const categoryLinks: Partial<Record<ContentCategory, PageLink>> = {
  interactive_cases: { path: "/vaka-ile-ogren", label: "Vaka ile Öğren" },
  clinical_cards: { path: "/klinik-kartlar", label: "Klinik Kartlar" },
  drug_safety: { path: "/ilac-guvenligi", label: "İlaç Güvenliği" },
  diagnostic_error_atlas: { path: "/hata-atlasi", label: "Hata Atlası" },
  shift_companion: { path: "/nobet-dostu", label: "Nöbet Dostu" },
  guidelines: { path: "/rehberler", label: "Rehberler" },
  learning_modules: { path: "/egitim-modulleri", label: "Eğitim Modülleri" },
  evidence_radar: { path: "/makale-radar", label: "Makale Radarı" },
  journal_club: { path: "/makale-kulubu", label: "Makale Kulübü" },
  special_resuscitation: { path: "/ozel-durumlarda-resusitasyon", label: "Özel Durumlarda Resüsitasyon" },
  search: { path: "/arama", label: "İçerik Ara" },
};

const routes = manifest as ContentRouteEntry[];

function routeFor(pathname: string): ContentRouteEntry | undefined {
  const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  return routes.find((entry) => entry.path === path);
}

export function getPageContext(pathname: string): PageContext | undefined {
  if (pathname === "/") return undefined;
  const current = routeFor(pathname);
  if (!current) {
    const segment = `/${pathname.split("/").filter(Boolean)[0] ?? ""}`;
    const parent = Object.values(categoryLinks).find((link) => link?.path === segment) ?? { path: "/", label: "Ana Sayfa" };
    return { breadcrumbs: [parent], parent };
  }

  const category = categoryLinks[current.category];
  const isCategory = current.kind === "category_index" || current.path === category?.path;
  const parent = isCategory || !category ? { path: "/", label: "Ana Sayfa" } : category;
  const breadcrumbs = isCategory || !category
    ? [{ path: current.path, label: repairLegacyEncoding(current.title) }]
    : [category, { path: current.path, label: repairLegacyEncoding(current.title) }];

  return { breadcrumbs, parent };
}
